<template>
  <div>
    <!-- 顶部查询面板 -->
    <div class="top-operate-container">
      <el-form :inline="true" :model="searchFormData" class="operate-form" :disabled="loading">
        <el-form-item :label="$str.getKey('收益管理/日期')">
          <el-date-picker v-model="searchFormData.timer" type="month" value-format="YYYY-MM" :clearable="false"
            :disabled-date="disabledDatedisabledDate" @change="timeRangeChange" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getListData">{{ $str.getKey('收益管理/查询') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div style="display: flex; flex-florw: row; justify-content: space-between">
        <div class="title-text">{{ $str.getKey('收益管理/储能抄表结算单') }}</div>
        <div class="title-btn">
          <el-button type="primary" class="btn-print" @click="printFunc(tableRef1)">
            <el-icon style="margin-right: 6px">
              <Printer />
            </el-icon>{{ $str.getKey('收益管理/打印') }}
          </el-button>
          <el-button type="primary" class="btn-print" @click="exportTable('printTableA')">
            <el-icon style="margin-right: 6px">
              <Upload />
            </el-icon>{{ $str.getKey('收益管理/导出') }}
          </el-button>
          <!-- <vxe-button @click="exportEvent">导出</vxe-button> -->
        </div>
      </div>



      <div ref="tableRef1" id="print-panel1" class="panel-content">
        <table class="print-panel-table" :border="1" cellspacing="0" id="printTableA">
          <tbody>
            <tr>
              <td>{{ $str.getKey('收益管理/用户方') }}</td>
              <td colspan="5"> {{ totalAllData.overview && totalAllData.overview.fullName1 }}</td>
              <td>{{ $str.getKey('收益管理/投资方') }}</td>
              <td colspan="5"> {{ totalAllData.overview && totalAllData.overview.fullName2 }}</td>

            </tr>
            <tr>
              <td>{{ $str.getKey('收益管理/站点名称') }}</td>
              <td colspan="5"> {{ totalAllData.overview && totalAllData.overview.name }}</td>
              <td>{{ $str.getKey('收益管理/站点地址') }}</td>
              <td colspan="5"> {{ totalAllData.overview && totalAllData.overview.address }}</td>
            </tr>
            <tr>
              <td>{{ $str.getKey('收益管理/抄表日期') }}</td>
              <td colspan="5"> {{ totalAllData.overview && totalAllData.overview.queryDateStr }}</td>
              <td>{{ $str.getKey('收益管理/抄表方式') }}</td>
              <td colspan="5">{{ $str.getKey('收益管理/现场') }}</td>
            </tr>
            <tr>
              <td>{{ $str.getKey('收益管理/用电区间') }}</td>
              <td colspan="5"> {{
                totalAllData.startDate+
                "~" +
                totalAllData.endDate
                
              }}</td>
              <td>{{ $str.getKey('收益管理/实际用电天数') }}</td>
              <td colspan="5">{{ totalAllData.overview && totalAllData.overview.usageDays }}</td>
            </tr>

            <tr>
              <td>{{ $str.getKey('收益管理/蓄电量(kWh)') }}</td>
              <td>{{ $str.getKey('收益管理/放电量(kWh)') }}</td>
              <td>{{ $str.getKey('收益管理/损耗') }}</td>
              <td>{{ $str.getKey('收益管理/蓄电支付金额(元)') }}</td>
              <td>{{ $str.getKey('收益管理/放电支付金额(元)') }}</td>
              <td>{{ $str.getKey('收益管理/节约金额(元)') }}</td>
              <td  colspan="2">{{ $str.getKey('收益管理/分成') }}</td>
              <td>{{ $str.getKey('收益管理/甲方') }}</td>
              <td >{{ $str.getKey('收益管理/乙方') }}</td>
            </tr>
            <tr>
              <td>{{ totalAllData.overview && totalAllData.overview.chargeEle }}</td>
              <td>{{ totalAllData.overview && totalAllData.overview.dischargeEle }}</td>
              <td>{{ totalAllData.overview && totalAllData.overview.loss }}</td>
              <td>{{ totalAllData.overview && totalAllData.overview.chargeCost }}</td>
              <td>{{ totalAllData.overview && totalAllData.overview.dischargeIncome }}</td>
              <td>{{ totalAllData.overview && totalAllData.overview.actuallyIncome }}</td>
              <td colspan="2">{{ totalAllData.overview && totalAllData.overview.divideInto }}</td>
              <td>{{ totalAllData.overview && totalAllData.overview.ratioValueA }}</td>
              <td>{{ totalAllData.overview && totalAllData.overview.ratioValueB }}</td>
            </tr>
            <tr>
              <td colspan="2">{{ $str.getKey('收益管理/储能电费电价=蓄电支付金额/放电量') }}</td>
              <td>{{ totalAllData.overview && totalAllData.overview.esPriceLoss }}</td>
              <td colspan="2" rowspan="2">{{ $str.getKey('收益管理/因储能节省或增加基本电费节省为负值，增加为正值') }}</td>
              <td colspan="2" rowspan="2">{{ totalAllData.overview && totalAllData.overview.esPower }}</td>
              <td>{{ $str.getKey('收益管理/金额') }}</td>
              <td>{{ totalAllData.overview && totalAllData.overview.moneyA }}</td>
              <td>{{ totalAllData.overview && totalAllData.overview.moneyB }}</td>
            </tr>
            <tr>
              <td colspan="2">{{ $str.getKey('收益管理/蓄电功率') }}</td>
              <td>{{ totalAllData.overview && totalAllData.overview.esPowerA }}</td>
              <td>{{ $str.getKey('收益管理/甲方应付金额') }}</td>
              <td colspan="4">{{ totalAllData.overview && totalAllData.overview.moneyB }}</td>
            </tr>
            <tr>
              <td>{{ $str.getKey('收益管理/用能公司') }}</td>
              <td colspan="5">{{ totalAllData.overview && totalAllData.overview.fullName1 }}</td>
              <td>{{ $str.getKey('收益管理/节能公司（乙方）') }}</td>
              <td colspan="5">{{ totalAllData.overview && totalAllData.overview.fullName2 }}</td>
            </tr>
            <tr>
              <td>{{ $str.getKey('收益管理/时间:') }}</td>
              <td colspan="5"></td>
              <td>{{ $str.getKey('收益管理/时间：') }}</td>
              <td colspan="5"></td>
            </tr>
          </tbody>
        </table>
        <div class="remark-info-container">
          <span>{{ $str.getKey('收益管理/备注：') }}</span>
          <span>{{ props.remark }}</span>
        </div>
      </div>

    </div>
    <div class="mt-[40px]">
      <div style="display: flex; flex-florw: row; justify-content: space-between">
        <div class="title-text">{{ $str.getKey('收益管理/储能电站能源管理通知单') }}</div>
        <!-- <el-button type="primary" class="btn-print" v-print="'#print-panel1'">
          <el-icon style="margin-right: 6px"> <Printer /> </el-icon>打印
        </el-button> -->
        <div class="title-btn-bottom">
          <el-button type="primary" class="btn-print" @click="printFunc(tableRef2)">
            <el-icon style="margin-right: 6px">
              <Printer />
            </el-icon>{{ $str.getKey('收益管理/打印') }}
          </el-button>
          <el-button type="primary" class="btn-print" @click="exportTable('printTableB')">
            <el-icon style="margin-right: 6px">
              <Upload />
            </el-icon>{{ $str.getKey('收益管理/导出') }}
          </el-button>
        </div>
      </div>
      <div ref="tableRef2" class="panel-content">
        <table class="print-panel-table" :border="1" cellspacing="0" id="printTableB">
          <tbody>
            <tr>
              <td>{{ $str.getKey('收益管理/用户方') }}</td>
              <td colspan="4"> {{ totalAllData.overview && totalAllData.overview.fullName1 }}</td>
              <td>{{ $str.getKey('收益管理/投资方') }}</td>
              <td colspan="3"> {{ totalAllData.overview && totalAllData.overview.fullName2 }}</td>

            </tr>
            <tr>
              <td>{{ $str.getKey('收益管理/站点名称') }}</td>
              <td colspan="4"> {{ totalAllData.overview && totalAllData.overview.name }}</td>
              <td>{{ $str.getKey('收益管理/站点地址') }}</td>
              <td colspan="3"> {{ totalAllData.overview && totalAllData.overview.address }}</td>
            </tr>
            <tr>
              <td>{{ $str.getKey('收益管理/抄表日期') }}</td>
              <td colspan="4"> {{ totalAllData.overview && totalAllData.overview.queryDateStr }}</td>
              <td>{{ $str.getKey('收益管理/抄表方式') }}</td>
              <td colspan="3">{{ $str.getKey('收益管理/现场') }}</td>
            </tr>
            <tr>
              <td>{{ $str.getKey('收益管理/用电区间') }}</td>
              <td colspan="4"> {{
                totalAllData.startDate+
                "~" +
                totalAllData.endDate
                
              }}</td>
              <td>{{ $str.getKey('收益管理/实际用电天数') }}</td>
              <td colspan="3">{{ totalAllData.overview && totalAllData.overview.usageDays }}</td>
            </tr>
            </tbody>
            <tbody v-for="(tableItem, index) in totalAllData.meters" :key="index">
            <tr >
              <td >{{ $str.getKey('收益管理/电表名称') }}</td>
              <td>{{ $str.getKey('收益管理/计量类型') }}</td>
              <td width="150">{{ $str.getKey('收益管理/汇流柜') }}</td>
              <td>{{ $str.getKey('收益管理/倍率') }}</td>
              <td>{{ $str.getKey('收益管理/上月表数') }}</td>
              <td>{{ $str.getKey('收益管理/本月表数') }}</td>
              <td>{{ $str.getKey('收益管理/电量') }}</td>
              <td>{{ $str.getKey('收益管理/单价') }}</td>
              <td>{{ $str.getKey('收益管理/电费(元)') }}</td>
            </tr>
              <tr v-for='item in tableList[index]'  :key="index">
                <td  width="100">{{ item.chargeEle }}</td>
                <td width="100">{{item.dischargeEle}}</td>
                <td width="150">{{item.loss}}</td>
                <td width="100">{{ item.chargeCost }}</td>
                <td width="100">{{ item.dischargeIncome }}</td>
                <td width="100">{{ item.actuallyIncome }}</td>
                <td width="100">{{ item.address }}</td>
                <td width="100">{{ item.ratio1 }}</td>
                <td width="100">{{ item.ratio2 }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed } from "vue";
import dayjs from "dayjs";
import { getIncomeData } from "./api/index.js";
import useAppStore from "@/store/modules/app";
import { getMonthRange, disabledHalfYear, normalizeOverview } from "./shared/statementData.js";
import { printElement, exportTableToExcel } from "./shared/statementExport.js";

const $str = window.$str;

const totalAllData = ref([]);
const props = defineProps(["stationId", "remark"]);
// 搜索面板-form-data
const searchFormData = reactive({
  timer: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM")
});

const appStore = useAppStore();
/** 获取stationId，并监听其变化-更新数据 */
const stationId = computed(() => appStore.stationId);
const stationName = computed(() => appStore.stationName);
console.log("电站ID：" + stationId.value + "，电站名称：" + (typeof stationName.value === 'object' ? JSON.stringify(stationName.value) : stationName.value))
// 监听 stationId 变化
watch(() => appStore.stationId, (newStationId) => {
  if (newStationId) {
    getListData();
  }
}, { immediate: true });
const gridRef = ref(null);
const tableRef1 = ref(null);
const tableRef2 = ref(null);

const gridOptions2 = reactive({
  border: true,
  mergeCells: [
    { row: 0, col: 0, rowspan: 12, colspan: 0 },
    { row: 0, col: 1, rowspan: 5, colspan: 1 },
    { row: 6, col: 1, rowspan: 5, colspan: 1 }
  ]
});

const tableList = ref([]);
const tableDataMeters = computed(() => {
  return tableList.value.map(item => item);
});

const remarkInfoList = ref([
  "注：甲方每月支付乙方的储能服务费为峰谷价差收益的总和，其中电量计量以储能电站并网点总表计量为准，对应时段度电电价以当地供电部门实际执行电价为准，具体计算公式如下：",
  "1. 放电电费 = ∑(储能系统各时段（峰、平、谷、（深谷））并网点总表放电电量 ×对应时段度电电价)",
  "2. 充电电费 = ∑(储能系统各时段（峰、平、谷、（深谷））并网点总表充电电量 × 对应时段度电电价)",
  "3. 峰谷价差收益 = 放电电费 - 充电电费",
  "4. 储能电站收益 = 峰谷价差收益"
]);


onMounted(() => {
  getListData();
});

/** 设置日期的禁选范围 */
const disabledDatedisabledDate = disabledHalfYear;
function getListData() {
  const { firstDay, lastDay } = getMonthRange(searchFormData.timer);
  totalAllData.value = [];
  getIncomeData({
    startDate: firstDay,
    endDate: lastDay,
    stationId: stationId.value
  }).then(res => {
    totalAllData.value = JSON.parse(JSON.stringify(res.data));
    normalizeOverview(totalAllData.value.overview);

    totalAllData.value.startDate = firstDay;
    totalAllData.value.endDate = lastDay;

    formatterMetersData(totalAllData.value.meters);
  });
}

function formatterMetersData(metersData) {
  let targetFom = [
    {
      chargeEle: "meterName",
      dischargeEle: "储能充电",
      loss: "正向有功总电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastTotalChg",
      actuallyIncome: "thisTotalChg",
      address: "qoeTotalChg",
      ratio1: "",
      ratio2: "costTotalChg"
    },
    {
      chargeEle: "meterName",
      dischargeEle: "储能充电",
      loss: "正向有功尖电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastSharpChg",
      actuallyIncome: "thisSharpChg",
      address: "qoeSharpChg",
      ratio1: "priceSharpChg",
      ratio2: "costSharpChg"
    },
    {
      chargeEle: "meterName",
      dischargeEle: "储能充电",
      loss: "正向有功峰电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastPeakChg",
      actuallyIncome: "thisPeakChg",
      address: "qoePeakChg",
      ratio1: "pricePeakChg",
      ratio2: "costPeakChg"
    },
    {
      chargeEle: "meterName",
      dischargeEle: "储能充电",
      loss: "正向有功平电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastFlatChg",
      actuallyIncome: "thisFlatChg",
      address: "qoeFlatChg",
      ratio1: "priceFlatChg",
      ratio2: "costFlatChg"
    },
    {
      chargeEle: "meterName",
      dischargeEle: "储能充电",
      loss: "正向有功谷电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastValleyChg",
      actuallyIncome: "thisValleyChg",
      address: "qoeValleyChg",
      ratio1: "priceValleyChg",
      ratio2: "costValleyChg"
    },
    {
      chargeEle: "meterName",
      dischargeEle: "储能充电",
      loss: "正向有功深谷电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastDeepChg",
      actuallyIncome: "thisDeepChg",
      address: "qoeDeepChg",
      ratio1: "priceDeepChg",
      ratio2: "costDeepChg"
    },
    {
      chargeEle: "meterName",
      dischargeEle: "储能放电",
      loss: "反向有功总电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastTotalDis",
      actuallyIncome: "thisTotalDis",
      address: "qoeTotalDis",
      ratio1: "",
      ratio2: "incomeTotalDis"
    },
    {
      chargeEle: "meterName",
      dischargeEle: "储能放电",
      loss: "反向有功尖电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastSharpDis",
      actuallyIncome: "thisSharpDis",
      address: "qoeSharpDis",
      ratio1: "priceSharpDis",
      ratio2: "incomeSharpDis"
    },
    {
      chargeEle: "meterName",
      dischargeEle: "储能放电",
      loss: "反向有功峰电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastPeakDis",
      actuallyIncome: "thisPeakDis",
      address: "qoePeakDis",
      ratio1: "pricePeakDis",
      ratio2: "incomePeakDis"
    },
    {
      chargeEle: "meterName",
      dischargeEle: "储能放电",
      loss: "反向有功平电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastFlatDis",
      actuallyIncome: "thisFlatDis",
      address: "qoeFlatDis",
      ratio1: "priceFlatDis",
      ratio2: "incomeFlatDis"
    },
    {
      chargeEle: "meterName",
      dischargeEle: "储能放电",
      loss: "反向有功谷电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastValleyDis",
      actuallyIncome: "thisValleyDis",
      address: "qoeValleyDis",
      ratio1: "priceValleyDis",
      ratio2: "incomeValleyDis"
    },
    {
      chargeEle: "meterName",
      dischargeEle: "储能放电",
      loss: "反向有功深谷电量(kWh)",
      chargeCost: "magnification",
      dischargeIncome: "lastDeepDis",
      actuallyIncome: "thisDeepDis",
      address: "qoeDeepDis",
      ratio1: "priceDeepDis",
      ratio2: "incomeDeepDis"
    },
    {
      chargeEle: "",
      dischargeEle: "合计",
      loss: "",
      chargeCost: "",
      dischargeIncome: "",
      actuallyIncome: "",
      address: "",
      ratio1: "",
      ratio2: "actuallyIncome"
    }
  ];

  function processMeterData(meter) {
    const processedData = [];

    targetFom.forEach(formItem => {
      const data = {
        chargeEle: meter[formItem.chargeEle],
        dischargeEle: formItem.dischargeEle,
        loss: formItem.loss,
        chargeCost: meter[formItem.chargeCost || ""],
        dischargeIncome: meter[formItem.dischargeIncome],
        actuallyIncome: meter[formItem.actuallyIncome],
        address: meter[formItem.address],
        ratio1: meter[formItem.ratio1],
        ratio2: meter[formItem.ratio2]
      };

      processedData.push(data);
    });

    return processedData;
  }
  tableList.value = [];
  metersData.map(item => {
    tableList.value.push(processMeterData(item));
  });
}

/** 打印-抄表详情 */
function printFunc(el) {
  printElement(el);
}

/** 导出-抄表详情 */
function exportTable(id) {
  exportTableToExcel(id, '抄表详情')
}


const timeRangeChange = val => {
  searchFormData.timer = val;
};
</script>

<style lang="scss" scoped>
.meterDataTable {
  margin: 20px 0;
}

.remark-info-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  color: #696868;
  .info-text {
    font-family: PingFang-SC, PingFang-SC;
    font-weight: bold;
    font-size: 14px;
    
    line-height: 38px;
    text-align: left;
  }
}

table,
table tr th,
table tr td {
  color: #9d9ea0;
  border: 1px solid #525151;
}

table {
  min-height: 25px;
  line-height: 45px;
  text-align: center;
  border-collapse: collapse;
  width: 1050px
}

.print-panel-table {
  // margin:0 auto;
}


::v-deep .el-descriptions__cell el-descriptions__label is-bordered-label {
  color: #ffffff;
}

::v-deep .el-descriptions__label.el-descriptions__cell.is-bordered-label {
  background-color: unset !important;
}

::v-deep .vxe-table--render-default .vxe-table--body-wrapper table {
  background-color: #373f58 !important;
  color: #ffffff !important;
}

::v-deep .vxe-table--render-default.border--full .vxe-body--column,
.vxe-table--render-default.border--full .vxe-footer--column,
.vxe-table--render-default.border--full {
  background-image: linear-gradient(#4b5369, #4b5369),
    linear-gradient(#4b5369, #4b5369) !important;
}

::v-deep .vxe-header--column {
  background-image: linear-gradient(#4b5369, #4b5369),
    linear-gradient(#4b5369, #4b5369) !important;
}

::v-deep .vxe-table--render-default.border--full .vxe-footer--column {
  background-image: linear-gradient(#4b5369, #4b5369),
    linear-gradient(#4b5369, #4b5369) !important;
}

::v-deep .vxe-table--header-wrapper {
  background-color: #4b5369 !important;
}

::v-deep .vxe-table .vxe-table--header-wrapper .vxe-table--header-border-line {
  border-bottom: 1px solid #4b5369;
}

::v-deep .vxe-table .vxe-table--header-wrapper,
.vxe-table--render-default {
  color: #ffffff !important;
}

::v-deep .vxe-header--row {
  background-color: #373f58 !important;
}

::v-deep .vxe-table--render-default .vxe-table--border-line {
  border: 1px solid #4b5369 !important;
}

.title-text {
  line-height: 26px;
  font-size: 18px;
  border-left: 10px solid blue;
  padding-left: 10px;
  margin-bottom: 10px;
}

.panel-content {
  // width: 80%;
  // margin:0 auto
  margin-top: 20px;
}

.title-btn {
  position: relative;
  right: 27px;
  bottom: 51px;
}

.title-btn-bottom {
  position: relative;
  right: 27px;
}

// 查询/打印/导出按钮:系统统一主色
:deep(.el-button--primary),
:deep(.btn-print) {
  background-color: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
  color: #fff !important;

  span,
  .el-icon {
    color: #fff !important;
  }
}
</style>
